import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, FileSignature } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { track } from '@/lib/analytics';

const StickyCallBar = ({ phoneDisplay = '(936) 828-2500', phoneTel = '9368282500' }) => {
  const { t } = useLanguage();

  useEffect(() => {
    document.body.classList.add('has-sticky-bar');
    return () => document.body.classList.remove('has-sticky-bar');
  }, []);

  return (
    <div className="sticky-call-bar" data-testid="sticky-call-bar">
      <a href={`tel:${phoneTel}`} className="btn-brass" onClick={() => track('phone_click', { location: 'sticky_bar' })} data-testid="sticky-call-btn">
        <Phone size={16} /> {t('common.callNow')}
      </a>
      <Link to="/start-a-bond" className="btn-red" onClick={() => track('start_bond_click', { location: 'sticky_bar' })} data-testid="sticky-start-bond-btn">
        <FileSignature size={16} /> {t('common.startBond')}
      </Link>
    </div>
  );
};

export default StickyCallBar;
